export default "__VITE_ASSET__DPz13UYB__"